import { ShipmentCollection } from '../../../models/Shipment/ShipmentCollection.js';
import { ServiceMapper } from '../../../domains/service/ServiceMapper.js';
import { Place } from '../../../models/Place/Place.js';
import { Parcel } from '../../../models/Parcel/Parcel.js';
import { PriceMapper } from '../../../models/Price/PriceMapper.js';

class Summary {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  get(reference) {
    return this.apiClient.get(`com/orders/${reference}/summary`).then(response => {
      const {
        customs,
        client_id,
        collection,
        from,
        has_customs,
        label_url,
        shipment_reference,
        packages,
        price,
        products,
        service,
        to,
        order_reference
      } = response.data;
      return {
        clientId: client_id,
        collection: collection ? ShipmentCollection.createFromResponse({
          collection_date: collection.date,
          collection_time: collection.time
        }) : null,
        customs: {
          customsInvoiceId: (customs === null || customs === void 0 ? void 0 : customs.customs_invoice_id) || '',
          hasCustoms: !!has_customs
        },
        from: Place.createFromResponse(from),
        labels: label_url,
        parcels: packages.map(Parcel.createFromResponse),
        price: PriceMapper.createModelFromResponse({
          price,
          products
        }),
        reference: shipment_reference,
        service: ServiceMapper.createFromComOrderSummaryServiceResponse(service),
        to: Place.createFromResponse(to),
        orderReference: order_reference
      };
    });
  }
}

export { Summary };
//# sourceMappingURL=Summary.js.map
